import { ApolloLink, ApolloProvider, HttpLink } from '@apollo/client';
import DebounceLink from 'apollo-link-debounce';
import { getLocalStorage } from 'libs/utils/logic/ui/systemLogic';
import { useContext, useMemo } from 'react';
import { GlobalContext } from 'session/state/context';
import { GraphQLResponseLogger, createApolloClient } from 'static/api/endpoint';
import Config, { LOCAL_STORAGE_AUTH_HEADER_KEY } from 'static/config/coreConfig';

interface Props {
    children?: React.ReactNode;
}

export const GraphQLProvider = (props: Props) => {
    const {
        state: { loggedUser }
    } = useContext(GlobalContext);

    const authValue = getLocalStorage(LOCAL_STORAGE_AUTH_HEADER_KEY);

    const debounceLink = new DebounceLink(500);

    const httpLink = new HttpLink({
        uri: `${Config.ApiBaseUrl}/v2/graphql`,
        headers: authValue
            ? {
                  Authorization: authValue
              }
            : {}
    });
    const link = ApolloLink.from([debounceLink, GraphQLResponseLogger, httpLink]);
    const apolloClient = useMemo(() => createApolloClient(link), [loggedUser?.userId]);
    return <ApolloProvider client={apolloClient}>{props.children}</ApolloProvider>;
};
